// 画像のmax-width設定関数
export const initBorderGrayMaxWidth = () => {
  const setBorderGrayMaxWidth = () => {
    const borderGrayImages = document.querySelectorAll('.item-img .border-gray, .zoom .border-gray');
    
    borderGrayImages.forEach(img => {
      // 画像が読み込まれた後に処理
      const setMaxWidth = () => {
        // Safari対応：より長い遅延とwindow.loadイベント後に実行
        setTimeout(() => {
          // 画像の自然なサイズを取得
          const naturalWidth = img.naturalWidth;
          
          // CSSのobject-fit: containが適用された実際の表示サイズを計算
          const container = img.closest('.item-img') || img.closest('.zoom .image');
          if (!container) return;
          
          const containerRect = container.getBoundingClientRect();
          const containerWidth = containerRect.width;
          const containerHeight = containerRect.height;
          
          // paddingを除いた利用可能サイズ
          const computedStyle = getComputedStyle(container);
          const paddingLeft = parseFloat(computedStyle.paddingLeft) || 0;
          const paddingRight = parseFloat(computedStyle.paddingRight) || 0;
          const paddingTop = parseFloat(computedStyle.paddingTop) || 0;
          const paddingBottom = parseFloat(computedStyle.paddingBottom) || 0;
          
          const availableWidth = containerWidth - paddingLeft - paddingRight;
          const availableHeight = containerHeight - paddingTop - paddingBottom;
          
          // object-fit: containを考慮した実際の表示サイズを計算
          const imgAspectRatio = naturalWidth / img.naturalHeight;
          const containerAspectRatio = availableWidth / availableHeight;
          
          let actualDisplayWidth;
          if (imgAspectRatio > containerAspectRatio) {
            // 画像が横長：幅に合わせる
            actualDisplayWidth = availableWidth;
          } else {
            // 画像が縦長：高さに合わせて幅を計算
            actualDisplayWidth = availableHeight * imgAspectRatio;
          }
          
          // 自然サイズとの小さい方を使用
          const targetWidth = Math.min(naturalWidth, actualDisplayWidth);
          
          if (targetWidth > 0) {
            img.style.maxWidth = `${targetWidth}px`;
          }
        }, 100); // 100ms遅延でSafariの描画完了を待つ
      };
      
      if (img.complete && img.naturalWidth > 0) {
        setMaxWidth();
      } else {
        img.addEventListener('load', setMaxWidth);
      }
    });
  };

  // window.loadイベント後に実行（Safari対応）
  if (document.readyState === 'complete') {
    setBorderGrayMaxWidth();
  } else {
    window.addEventListener('load', setBorderGrayMaxWidth);
  }
  
  // リサイズ時の再計算
  window.addEventListener('resize', setBorderGrayMaxWidth);
};